module.exports = __webpack_public_path__ + "static/media/top.4d99e041.png";